import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * A route redirect that carries the current query string with it.
 *
 * The email verification link lands on /login?verified=true&token=... and the
 * resend link on /dashboard?verified=true&token=... A signed-in registrant is
 * redirected away from both before the page that reads the token mounts, so a
 * bare `<Navigate to="/path" />` silently drops the token and the address is
 * never verified. Every auth redirect in App.js goes through this instead.
 */
export default function RedirectKeepQuery({ to }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search }} />;
}
